import { humanRedeemableAmount } from '~/lib/PackageHelpers';
import { minutesToDuration } from '~/lib/DateTime';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import React from 'react';

export default function getRedeemableError(eventTypes, redeemableFor) {
    const type = redeemableFor?.type;
    const amount = parseInt(redeemableFor?.amount) + 1;

    const typeToProperty = {
        minutes: 'duration',
        price: 'price',
    };
    const property = typeToProperty[type];

    if (!property || !eventTypes?.length) {
        return null;
    }

    const insufficientForEventTypes = eventTypes
        .filter(et => et[property] > amount)
        .filter(et =>
            (redeemableFor?.eventTypes || []).find(
                enabledTypeId => parseInt(enabledTypeId) === parseInt(et.id),
            ),
        );
    if (!insufficientForEventTypes?.length) {
        return null;
    }

    return (
        <div>
            <div>
                The amount this package is redeemable for (
                {humanRedeemableAmount(
                    redeemableFor?.type,
                    redeemableFor?.amount,
                )}
                ) is not enough for these types:
            </div>
            <ul>
                {insufficientForEventTypes.map(eventType => (
                    <li>
                        {eventType.name} (
                        {minutesToDuration(eventType.duration)} for{' '}
                        {formatCurrency(eventType.price)})
                    </li>
                ))}
            </ul>
        </div>
    );
}
